module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/question-new/question-new.component.css
// module id = ./src/app/admin/question-new/question-new.component.css
// module chunks = main